import axios from 'axios'
import { getRestApiConfig } from '../config'

export const getHelp = async (key: string): Promise<string> => {
    const restApiConfig = getRestApiConfig()
    const endpointUrl = new URL(`api/v1/Texts/Help?key=${key}`, restApiConfig.baseUrl).href
    const res = await axios.get<string>(endpointUrl, { headers: { ...restApiConfig.authHeader } })
    return res.data
}
